import { debounce } from "@sazka/utils/debounce";

let container: JQuery<HTMLElement> = null;
let state: Record<string, any> = {};

export const useBreadcrumbs = () => {
    const $breadcrumbsContainer = $(".footer-breadcrumbs-container .footer-breadcrumbs__list");
    if ($breadcrumbsContainer.length) {
        initBreadcrumbs($breadcrumbsContainer);
    }
};

function initBreadcrumbs(c: JQuery<HTMLElement>) {
    container = c;
    state = {};

    state.items = container.children(":not(.footer-breadcrumbs__item--dots, .footer-breadcrumbs__item--home)");
    state.home = container.find(".footer-breadcrumbs__item--home");
    state.dots = container.find(".footer-breadcrumbs__item--dots");

    state.itemsWidth = Array.from(state.items).map(function (item) {
        return $(item).outerWidth();
    });
    state.totalItemsWidth = state.itemsWidth.reduce((total, value) => total + value);
    state.homeWidth = state.home.outerWidth();
    state.dots.show();
    state.dotsWidth = state.dots.outerWidth();
    state.dots.hide();
    hideOverflowingLinks();
    window.addEventListener(
        "resize",
        debounce(() => {
            hideOverflowingLinks();
        }, 100),
        { passive: true }
    );
}

function hideOverflowingLinks() {
    const max = container.width();
    if (max >= state.totalItemsWidth + state.homeWidth) {
        // show all
        state.dots.hide();
        state.items.each((_, elem) => {
            $(elem).show();
        });
    } else {
        // hide something and show dots
        state.dots.show();
        let subcount = state.homeWidth + state.dotsWidth;
        // keep items at the end, so traverse from end
        for (let i = state.itemsWidth.length - 1; i >= 0; i--) {
            subcount += state.itemsWidth[i];

            if (subcount > max) {
                // we want to show last item no mather what, just short it
                if (i == state.itemsWidth.length - 1) {
                    state.items.eq(i).outerWidth(state.itemsWidth[i] + max - subcount - 1);
                } else {
                    state.items.eq(i).hide();
                }
            } else {
                if (i == state.itemsWidth.length - 1) {
                    state.items.eq(i).width(max >= subcount ? "auto" : state.itemsWidth[i] + max - subcount - 1);
                } else {
                    state.items.eq(i).show();
                }
            }
        }
    }
}
